// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableCell-module__TableCell__Sorted--fimvQ{background-color:#f5f6f7}`, "",{"version":3,"sources":["webpack://./src/components/design/migrated/Table/TableCell.module.scss","webpack://./src/components/design/migrated/Icon/_colors.scss"],"names":[],"mappings":"AAKE,4CACE,wBCUO","sourcesContent":["@use '../Icon/fonts' as *;\n@use '../Icon/colors' as *;\n\n.TableCell {\n\n  &__Sorted {\n    background-color: $background-light;\n  }\n\n}\n","/* stylelint-disable color-no-hex */\n\n/* new pallete from march 2021*/\n/* ui colors */\n$brand-darkorange: #cf4800;\n$brand-brightorange: #e55a00;\n$brand-lightorange: #fdefe6;\n$brand-superlightorange: #fdf6f2;\n$grey-900: #323842;\n$grey-800: #414752;\n$grey-700: #5c626e;\n$grey-600: #6f7582;\n$grey-500: #9499a3;\n$grey-400: #bbc0c9;\n$grey-300: #dadde3;\n$grey-200: #ebecf0;\n$grey-100: #f5f6f7;\n$ui-white: #fff;\n$ui-green: #167922;\n$ui-red: #bc1c0e;\n\n/* data vis colours */\n$blue-800: #2b4c9b;\n$blue-700: #3456a6;\n$blue-600: #3c60b3;\n$blue-500: #4368bd;\n$blue-400: #6480c3;\n$blue-300: #879bcc;\n$blue-200: #afbbdb;\n$blue-100: #dbe0eb;\n$petrol-800: #428a81;\n$petrol-700: #4b9a91;\n$petrol-600: #4da9a1;\n$petrol-500: #54b9b1;\n$petrol-400: #63c8c2;\n$petrol-300: #81d7d3;\n$petrol-200: #b2edeb;\n$petrol-100: #e2ffff;\n$magenta-800: #97254f;\n$magenta-700: #ac2b55;\n$magenta-600: #c02d58;\n$magenta-500: #d2335f;\n$magenta-400: #d44a73;\n$magenta-300: #d76789;\n$magenta-200: #da91a7;\n$magenta-100: #ddbbc5;\n$yellow-800: #ee7c24;\n$yellow-700: #f58a27;\n$yellow-600: #fa9a2a;\n$yellow-500: #ffa52f;\n$yellow-400: #fdb244;\n$yellow-300: #fdc166;\n$yellow-200: #fed79a;\n$yellow-100: #ffebcc;\n$purple-800: #5c399b;\n$purple-700: #673fa2;\n$purple-600: #7249ad;\n$purple-500: #7b4db3;\n$purple-400: #8d69bb;\n$purple-300: #a387c8;\n$purple-200: #bfb0d4;\n$purple-100: #ddd8e4;\n$ext-grey-100: #d6d9dc;\n$ext-grey-200: #c0c5c8;\n$ext-grey-300: #9fa7ad;\n$ext-grey-400: #7f888e;\n$ext-grey-500: #6a757c;\n$ext-grey-600: #535d63;\n$ext-grey-700: #3b4145;\n$ext-grey-800: #171a1c;\n$red-100: #cba6a8;\n$red-200: #bb7471;\n$red-300: #b0504c;\n$red-400: #ba302a;\n$red-500: #bc1c0e;\n$red-600: #ad0e0e;\n$red-700: #9b0009;\n$red-800: #8f0001;\n$green-100: #bde5bd;\n$green-200: #98d299;\n$green-300: #73c375;\n$green-400: #59b75b;\n$green-500: #3dad42;\n$green-600: #329d38;\n$green-700: #24892c;\n$green-800: #167922;\n\n/* descriptive tokens */\n$text-heading: $grey-900;\n$text-default: $grey-800;\n$text-secondary-interactive: $grey-700;\n$text-lighter: $grey-600;\n$text-inactive: $grey-500;\n$stroke: $grey-400;\n$stroke-light: $grey-300;\n$background-darkest: $grey-600;\n$background-dark: $grey-300;\n$background-medium: $grey-200;\n$background-light: $grey-100;\n$color-focus: $yellow-200;\n\n/* end colours from design system */\n\n/* need to address these two */\n$modal-background: rgba(0, 10, 20, 0.5);\n$brand-brightorange-200: #ffd07c;\n\n/* stylelint-enable */\n\n$colors: 'brand-darkorange' $brand-darkorange, 'brand-brightorange' $brand-brightorange,\n  'brand-superlightorange' $brand-superlightorange, 'grey-800' $grey-800, 'grey-700' $grey-700, 'grey-600' $grey-600,\n  'grey-500' $grey-500, 'grey-400' $grey-400, 'grey-300' $grey-300, 'grey-200' $grey-200, 'grey-100' $grey-100,\n  'ext-grey-800' $ext-grey-800, 'ext-grey-700' $ext-grey-700, 'ext-grey-600' $ext-grey-600, 'ext-grey-500' $ext-grey-500,\n  'ext-grey-400' ext-$grey-400, 'ext-grey-300' $ext-grey-300, 'ext-grey-200' $ext-grey-200, 'ext-grey-100' ext-$grey-100,\n  'white' $ui-white, 'green' $ui-green, 'red' $ui-red, 'blue-800' $blue-800, 'blue-700' $blue-700, 'blue-600' $blue-600,\n  'blue-500' $blue-500, 'blue-400' $blue-400, 'blue-300' $blue-300, 'blue-200' $blue-200, 'blue-100' $blue-100,\n  'petrol-800' $petrol-800, 'petrol-700' $petrol-700, 'petrol-600' $petrol-600, 'petrol-500' $petrol-500,\n  'petrol-400' $petrol-400, 'petrol-300' $petrol-300, 'petrol-200' $petrol-200, 'petrol-100' $petrol-100,\n  'magenta-800' $magenta-800, 'magenta-700' $magenta-700, 'magenta-600' $magenta-600, 'magenta-500' $magenta-500,\n  'magenta-400' $magenta-400, 'magenta-300' $magenta-300, 'magenta-200' $magenta-200, 'magenta-100' $magenta-100,\n  'yellow-800' $yellow-800, 'yellow-700' $yellow-700, 'yellow-600' $yellow-600, 'yellow-500' $yellow-500,\n  'yellow-400' $yellow-400, 'yellow-300' $yellow-300, 'yellow-200' $yellow-200, 'yellow-100' $yellow-100,\n  'purple-800' $purple-800, 'purple-700' $purple-700, 'purple-600' $purple-600, 'purple-500' $purple-500,\n  'purple-400' $purple-400, 'purple-300' $purple-300, 'purple-200' $purple-200, 'purple-100' $purple-100,\n  'red-800' $red-800, 'red-700' $red-700, 'red-600' $red-600, 'red-500' $red-500, 'red-400' $red-400, 'red-300' $red-300,\n  'red-200' $red-200, 'red-100' $red-100, 'green-800' $green-800, 'green-700' $green-700, 'green-600' $green-600,\n  'green-500' $green-500, 'green-400' $green-400, 'green-300' $green-300, 'green-200' $green-200, 'green-100' $green-100,\n  'ui-green' $ui-green, 'ui-red' $ui-red, 'text-heading' $text-heading, 'text-default' $text-default,\n  'text-secondary-interactive' $text-secondary-interactive, 'text-lighter' $text-lighter, 'text-inactive' $text-inactive,\n  'stroke' $stroke, 'stroke-light' $stroke-light, 'background-darkest' $background-darkest,\n  'background-dark' $background-dark, 'background-medium' $background-medium, 'background-light' $background-light,\n  'color-focus' $color-focus;\n\n/* stylelint-disable */\n:export {\n  brand-darkorange: $brand-darkorange;\n  brand-brightorange: $brand-brightorange;\n  brand-superlightorange: $brand-superlightorange;\n  grey-800: $grey-800;\n  grey-700: $grey-700;\n  grey-600: $grey-600;\n  grey-500: $grey-500;\n  grey-400: $grey-400;\n  grey-300: $grey-300;\n  grey-200: $grey-200;\n  grey-100: $grey-100;\n  white: $ui-white;\n  green: $ui-green;\n  red: $ui-red;\n  blue-800: $blue-800;\n  blue-700: $blue-700;\n  blue-600: $blue-600;\n  blue-500: $blue-500;\n  blue-400: $blue-400;\n  blue-300: $blue-300;\n  blue-200: $blue-200;\n  blue-100: $blue-100;\n  petrol-800: $petrol-800;\n  petrol-700: $petrol-700;\n  petrol-600: $petrol-600;\n  petrol-500: $petrol-500;\n  petrol-400: $petrol-400;\n  petrol-300: $petrol-300;\n  petrol-200: $petrol-200;\n  petrol-100: $petrol-100;\n  magenta-800: $magenta-800;\n  magenta-700: $magenta-700;\n  magenta-600: $magenta-600;\n  magenta-500: $magenta-500;\n  magenta-400: $magenta-400;\n  magenta-300: $magenta-300;\n  magenta-200: $magenta-200;\n  magenta-100: $magenta-100;\n  yellow-800: $yellow-800;\n  yellow-700: $yellow-700;\n  yellow-600: $yellow-600;\n  yellow-500: $yellow-500;\n  yellow-400: $yellow-400;\n  yellow-300: $yellow-300;\n  yellow-200: $yellow-200;\n  yellow-100: $yellow-100;\n  green-800: $green-800;\n  green-700: $green-700;\n  green-600: $green-600;\n  green-500: $green-500;\n  green-400: $green-400;\n  green-300: $green-300;\n  green-200: $green-200;\n  green-100: $green-100;\n  red-800: $red-800;\n  red-700: $red-700;\n  red-600: $red-600;\n  red-500: $red-500;\n  red-400: $red-400;\n  red-300: $red-300;\n  red-200: $red-200;\n  red-100: $red-100;\n  purple-800: $purple-800;\n  purple-700: $purple-700;\n  purple-600: $purple-600;\n  purple-500: $purple-500;\n  purple-400: $purple-400;\n  purple-300: $purple-300;\n  purple-200: $purple-200;\n  purple-100: $purple-100;\n  ext-grey-800: $ext-grey-800;\n  ext-grey-700: $ext-grey-700;\n  ext-grey-600: $ext-grey-600;\n  ext-grey-500: $ext-grey-500;\n  ext-grey-400: $ext-grey-400;\n  ext-grey-300: $ext-grey-300;\n  ext-grey-200: $ext-grey-200;\n  ext-grey-100: $ext-grey-100;\n  ui-green: $ui-green;\n  ui-red: $ui-red;\n  text-heading: $text-heading;\n  text-default: $text-default;\n  text-secondary-interactive: $text-secondary-interactive;\n  text-lighter: $text-lighter;\n  text-inactive: $text-inactive;\n  stroke: $stroke;\n  stroke-light: $stroke-light;\n  background-darkest: $background-darkest;\n  background-dark: $background-dark;\n  background-medium: $background-medium;\n  background-light: $background-light;\n  color-focus: $color-focus;\n  colors-0: $blue-500;\n  colors-1: $petrol-500;\n  colors-2: $yellow-500;\n  colors-3: $magenta-500;\n  colors-4: $purple-500;\n  colors-5: $blue-300;\n  colors-6: $purple-200;\n  colors-7: $magenta-800;\n  colors-8: $petrol-600;\n  colors-9: $yellow-100;\n  colors-10: $yellow-400;\n  colors-11: $purple-400;\n  colors-12: $blue-200;\n  colors-13: $magenta-200;\n  colors-14: $petrol-300;\n  colors-15: $magenta-400;\n  colors-16: $purple-800;\n  colors-17: $yellow-700;\n  colors-18: $purple-300;\n  colors-19: $petrol-800;\n  colors-20: $yellow-200;\n  colors-21: $blue-400;\n  colors-22: $magenta-100;\n  colors-23: $petrol-700;\n  colors-24: $purple-100;\n  colors-25: $magenta-600;\n  colors-26: $petrol-100;\n  colors-27: $yellow-300;\n  colors-28: $blue-100;\n  colors-29: $purple-700;\n}\n\n/* stylelint-enable */\n"],"sourceRoot":""}]);
// Exports
var _1 = `"Lato",sans-serif`;
export { _1 as "font-primary" };
export var micro = `12px`;
export var caption = `14px`;
var _2 = `#cf4800`;
export { _2 as "brand-darkorange" };
var _3 = `#e55a00`;
export { _3 as "brand-brightorange" };
var _4 = `#fdf6f2`;
export { _4 as "brand-superlightorange" };
var _5 = `#414752`;
export { _5 as "grey-800" };
var _6 = `#5c626e`;
export { _6 as "grey-700" };
var _7 = `#6f7582`;
export { _7 as "grey-600" };
var _8 = `#9499a3`;
export { _8 as "grey-500" };
var _9 = `#bbc0c9`;
export { _9 as "grey-400" };
var _a = `#dadde3`;
export { _a as "grey-300" };
var _b = `#ebecf0`;
export { _b as "grey-200" };
var _c = `#f5f6f7`;
export { _c as "grey-100" };
export var white = `#fff`;
export var green = `#167922`;
export var red = `#bc1c0e`;
var _d = `#2b4c9b`;
export { _d as "blue-800" };
var _e = `#3456a6`;
export { _e as "blue-700" };
var _f = `#3c60b3`;
export { _f as "blue-600" };
var _10 = `#4368bd`;
export { _10 as "blue-500" };
var _11 = `#6480c3`;
export { _11 as "blue-400" };
var _12 = `#879bcc`;
export { _12 as "blue-300" };
var _13 = `#afbbdb`;
export { _13 as "blue-200" };
var _14 = `#dbe0eb`;
export { _14 as "blue-100" };
var _15 = `#428a81`;
export { _15 as "petrol-800" };
var _16 = `#4b9a91`;
export { _16 as "petrol-700" };
var _17 = `#4da9a1`;
export { _17 as "petrol-600" };
var _18 = `#54b9b1`;
export { _18 as "petrol-500" };
var _19 = `#63c8c2`;
export { _19 as "petrol-400" };
var _1a = `#81d7d3`;
export { _1a as "petrol-300" };
var _1b = `#b2edeb`;
export { _1b as "petrol-200" };
var _1c = `#e2ffff`;
export { _1c as "petrol-100" };
var _1d = `#97254f`;
export { _1d as "magenta-800" };
var _1e = `#ac2b55`;
export { _1e as "magenta-700" };
var _1f = `#c02d58`;
export { _1f as "magenta-600" };
var _20 = `#d2335f`;
export { _20 as "magenta-500" };
var _21 = `#d44a73`;
export { _21 as "magenta-400" };
var _22 = `#d76789`;
export { _22 as "magenta-300" };
var _23 = `#da91a7`;
export { _23 as "magenta-200" };
var _24 = `#ddbbc5`;
export { _24 as "magenta-100" };
var _25 = `#ee7c24`;
export { _25 as "yellow-800" };
var _26 = `#f58a27`;
export { _26 as "yellow-700" };
var _27 = `#fa9a2a`;
export { _27 as "yellow-600" };
var _28 = `#ffa52f`;
export { _28 as "yellow-500" };
var _29 = `#fdb244`;
export { _29 as "yellow-400" };
var _2a = `#fdc166`;
export { _2a as "yellow-300" };
var _2b = `#fed79a`;
export { _2b as "yellow-200" };
var _2c = `#ffebcc`;
export { _2c as "yellow-100" };
var _2d = `#167922`;
export { _2d as "green-800" };
var _2e = `#24892c`;
export { _2e as "green-700" };
var _2f = `#329d38`;
export { _2f as "green-600" };
var _30 = `#3dad42`;
export { _30 as "green-500" };
var _31 = `#59b75b`;
export { _31 as "green-400" };
var _32 = `#73c375`;
export { _32 as "green-300" };
var _33 = `#98d299`;
export { _33 as "green-200" };
var _34 = `#bde5bd`;
export { _34 as "green-100" };
var _35 = `#8f0001`;
export { _35 as "red-800" };
var _36 = `#9b0009`;
export { _36 as "red-700" };
var _37 = `#ad0e0e`;
export { _37 as "red-600" };
var _38 = `#bc1c0e`;
export { _38 as "red-500" };
var _39 = `#ba302a`;
export { _39 as "red-400" };
var _3a = `#b0504c`;
export { _3a as "red-300" };
var _3b = `#bb7471`;
export { _3b as "red-200" };
var _3c = `#cba6a8`;
export { _3c as "red-100" };
var _3d = `#5c399b`;
export { _3d as "purple-800" };
var _3e = `#673fa2`;
export { _3e as "purple-700" };
var _3f = `#7249ad`;
export { _3f as "purple-600" };
var _40 = `#7b4db3`;
export { _40 as "purple-500" };
var _41 = `#8d69bb`;
export { _41 as "purple-400" };
var _42 = `#a387c8`;
export { _42 as "purple-300" };
var _43 = `#bfb0d4`;
export { _43 as "purple-200" };
var _44 = `#ddd8e4`;
export { _44 as "purple-100" };
var _45 = `#171a1c`;
export { _45 as "ext-grey-800" };
var _46 = `#3b4145`;
export { _46 as "ext-grey-700" };
var _47 = `#535d63`;
export { _47 as "ext-grey-600" };
var _48 = `#6a757c`;
export { _48 as "ext-grey-500" };
var _49 = `#7f888e`;
export { _49 as "ext-grey-400" };
var _4a = `#9fa7ad`;
export { _4a as "ext-grey-300" };
var _4b = `#c0c5c8`;
export { _4b as "ext-grey-200" };
var _4c = `#d6d9dc`;
export { _4c as "ext-grey-100" };
var _4d = `#167922`;
export { _4d as "ui-green" };
var _4e = `#bc1c0e`;
export { _4e as "ui-red" };
var _4f = `#323842`;
export { _4f as "text-heading" };
var _50 = `#414752`;
export { _50 as "text-default" };
var _51 = `#5c626e`;
export { _51 as "text-secondary-interactive" };
var _52 = `#6f7582`;
export { _52 as "text-lighter" };
var _53 = `#9499a3`;
export { _53 as "text-inactive" };
export var stroke = `#bbc0c9`;
var _54 = `#dadde3`;
export { _54 as "stroke-light" };
var _55 = `#6f7582`;
export { _55 as "background-darkest" };
var _56 = `#dadde3`;
export { _56 as "background-dark" };
var _57 = `#ebecf0`;
export { _57 as "background-medium" };
var _58 = `#f5f6f7`;
export { _58 as "background-light" };
var _59 = `#fed79a`;
export { _59 as "color-focus" };
var _5a = `#4368bd`;
export { _5a as "colors-0" };
var _5b = `#54b9b1`;
export { _5b as "colors-1" };
var _5c = `#ffa52f`;
export { _5c as "colors-2" };
var _5d = `#d2335f`;
export { _5d as "colors-3" };
var _5e = `#7b4db3`;
export { _5e as "colors-4" };
var _5f = `#879bcc`;
export { _5f as "colors-5" };
var _60 = `#bfb0d4`;
export { _60 as "colors-6" };
var _61 = `#97254f`;
export { _61 as "colors-7" };
var _62 = `#4da9a1`;
export { _62 as "colors-8" };
var _63 = `#ffebcc`;
export { _63 as "colors-9" };
var _64 = `#fdb244`;
export { _64 as "colors-10" };
var _65 = `#8d69bb`;
export { _65 as "colors-11" };
var _66 = `#afbbdb`;
export { _66 as "colors-12" };
var _67 = `#da91a7`;
export { _67 as "colors-13" };
var _68 = `#81d7d3`;
export { _68 as "colors-14" };
var _69 = `#d44a73`;
export { _69 as "colors-15" };
var _6a = `#5c399b`;
export { _6a as "colors-16" };
var _6b = `#f58a27`;
export { _6b as "colors-17" };
var _6c = `#a387c8`;
export { _6c as "colors-18" };
var _6d = `#428a81`;
export { _6d as "colors-19" };
var _6e = `#fed79a`;
export { _6e as "colors-20" };
var _6f = `#6480c3`;
export { _6f as "colors-21" };
var _70 = `#ddbbc5`;
export { _70 as "colors-22" };
var _71 = `#4b9a91`;
export { _71 as "colors-23" };
var _72 = `#ddd8e4`;
export { _72 as "colors-24" };
var _73 = `#c02d58`;
export { _73 as "colors-25" };
var _74 = `#e2ffff`;
export { _74 as "colors-26" };
var _75 = `#fdc166`;
export { _75 as "colors-27" };
var _76 = `#dbe0eb`;
export { _76 as "colors-28" };
var _77 = `#673fa2`;
export { _77 as "colors-29" };
export var TableCell__Sorted = `TableCell-module__TableCell__Sorted--fimvQ`;
export default ___CSS_LOADER_EXPORT___;
